import React from 'react';
import './PickDelivery.scss';
import { Divider } from 'antd';
import Checkbox from 'Components/Shared/Checkbox/Checkbox';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  name: string;
  text: string;
  price: number;
  code: string;
  isSelected: boolean;
  onDeliveryItemChange: (deliveryCode: string, isChecked: boolean) => void;
}

const DeliveryItem: React.SFC<IProps> = ({
  name,
  text = '',
  price,
  code,
  isSelected,
  onDeliveryItemChange,
}) => {

  const onChange = (isChecked: boolean) => {
    onDeliveryItemChange(code, isChecked);
  };

  const Description = () => (
    <div>
      <span className='medium-bold'>{ name }</span>
      { price > 0 ?
        <div>
          <PriceItem price={ price } decimals={ 2 } />
          { `. ${ text } ` }
        </div> :
        <div>
          <FormattedText
            displayName='Ingen avgift'
            formattedName='global.pricefree'
          />
          (<PriceItem price={ price } decimals={ 2 } />)
          { `. ${ text } ` }
        </div>
      }
    </div>
  );

  return (
    <>
      <Divider />
      <div className='delivery-item'>
        <Checkbox onChange={ onChange } value={ isSelected }>
          <Description />
        </Checkbox>
      </div>
    </>
  );
}

export default DeliveryItem;


// WEBPACK FOOTER //
// ./src/components/PickDelivery/DeliveryItem.tsx